module.exports = __webpack_public_path__ + "img/overview-user-icon.svg";